import React from "react";
import InfoUserDesktop from "./Desktop/InfoUserDesktop";
import InfoUserMobile from "./Mobile/InfoUserMobile";

const InfoUser = ({ info, tabletOrLess }) => {
  return (
    <>
      {!tabletOrLess ? (
        <InfoUserDesktop info={info} />
      ) : (
        <InfoUserMobile info={info} />
      )}
    </>
  );
};

export default InfoUser;
